import { Component } from "react";
import {
  Dimensions,
  Platform,
  View,
} from "react-native";

// import { Router, Scene, Stack, Drawer, Actions } from 'react-native-router-flux';
import Toast from 'react-native-toast-message';
import { NavigationContainer } from "@react-navigation/native";
import { createNativeStackNavigator } from "@react-navigation/native-stack";
// import { createDrawerNavigator } from "@react-navigation/drawer";
// import { Ionicons, MaterialCommunityIcons } from "@expo/vector-icons";
import { Provider } from "react-redux";
import { createStore, applyMiddleware } from "redux";
import ReduxThunk from "redux-thunk";
// import * as Notifications from "expo-notifications";
import * as Font from "expo-font";
/* Reducers */
import reducers from "./src/reducers";

/* Custom Actions */

/* Scenes */
import Login from "./src/scenes/Login";
import RegisterFirstStep from "./src/scenes/RegisterFirstStep";
import RegisterSecondStep from "./src/scenes/RegisterSecondStep";
import MyOrders from "./src/scenes/MyOrders";
import Profile from "./src/scenes/Profile";
import Settings from "./src/scenes/Settings";
import ContactUs from "./src/scenes/ContactUs";
import MyNotifications from "./src/scenes/MyNotifications";
import Activation from "./src/scenes/Activation.js";
// import Driver from './src/scenes/Driver.js';
import Text from "./src/components/Text";
import AboutUs from "./src/scenes/AboutUs.js";
import Home from "./src/scenes/Home.js";
import FindUs from "./src/scenes/FindUs.js";
import Service from './src/scenes/Service.js';
import Products from "./src/scenes/Products.js";
import Shop from "./src/scenes/Shop.js";

/* Utils */
import * as Commons from "./src/utils/Commons";
import { STRINGS, loadStrings } from "./src/utils/Strings";
import * as Constants from "./src/utils/Constants";
import Careers from "./src/scenes/Careers.js";
import Pharmacovigilance from "./src/scenes/Pharmacovigilance.js";
import OtpVerification from "./src/scenes/OtpVerification.js";
import ClientHomePage from "./src/scenes/ClientHomePage.js";
// import ClientHomePage from "./src/scenes/Shop.js";
import StatementOfAccount from "./src/scenes/StatementOfAccount.js";
import InvoiceDetails from "./src/scenes/InvoiceDetails.js";
import InvoicesReturns from "./src/scenes/InvoicesReturns.js";
import SplashScreen from "./src/scenes/Splash.js";
import OrderDetails from "./src/scenes/OrderDetails.js";
import OrderNow from "./src/scenes/OrderNow.js";
import ProductDetails from "./src/scenes/ProductDetails.js";
import Filters from "./src/scenes/Filters.js";
import checkout from "./src/scenes/CheckOut.js";
import Notifications from "./src/scenes/Notifications.js";
import Other from "./src/scenes/Other.js";
import NotificationsSettings from "./src/scenes/NotificationsSettings.js";
import OffersAndBestSellers from "./src/scenes/OffersAndBestSellers.js";

/* Other */
let width = Math.max(Dimensions.get("window").width, Constants.MIN_WIDTH);
// const BusyIndicator = require('../components/react-native-busy-indicator');
// const PTSans = require("./assets/PTSans-Regular.ttf");
// const Satoshi = require("./assets/Satoshi");

const store = createStore(reducers, {}, applyMiddleware(ReduxThunk));
// const Drawer = createDrawerNavigator();
const Stack = createNativeStackNavigator();
// const linking = {
//   prefixes: [Linking.createURL("/")], // this is the prefix for our app. Could be anything eg https://puresoft.ddns.net.com
//   config: {
//     screens: {
//       Home: "",
//     },
//   },
// };

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      initializationFinished: false,
      loggedIn: Constants.LOGGED_OUT,
      user: "",
      fontFamily: "riposte",
      fontSize: 16,
      notifications: [],
      badgeText: 0,
      _items: [],
    };
  }

  render() {
    if (!this.state.initializationFinished) {
      return null;
    }
    const routerProps = {
      navigationBarStyle: { backgroundColor: "white" },
      headerTintColor: "black",
    };

    const config = {};

    const linking = {};

    return (
      <Provider store={store}>
        <View style={{ flex: 1, paddingTop: Platform.OS === 'web' ? 0 : 20, backgroundColor: '#f9fdfe' }}>
          <NavigationContainer linking={linking} fallback={<Text>Loading...</Text>}>
            {this.getNavigator()}
          </NavigationContainer>
        </View>
        <Toast />
      </Provider>
    );
  }


  async UNSAFE_componentWillUpdate() {
    let count = 0;
    (await Commons.getNotifcations()).data.map((l) => {
      if (l.READ === 0) count++;
    });
    if (count !== this.state.badgeText) {
      this.setState({ badgeText: count });
    }
  }

  async componentDidMount() {
    await Commons.saveToAS("customerUSERNAME", "");
    await Commons.saveToAS("customerMOBILE", "");
    await loadStrings();

    // Load fonts for native platforms only (web fonts are loaded via CSS)
    if (Platform.OS !== 'web') {
      try {
        await Font.loadAsync({
          'Satoshi': require('./assets/fonts/Satoshi-Regular.ttf'),
          'Satoshi-Regular': require('./assets/fonts/Satoshi-Regular.ttf'),
          'Satoshi-Medium': require('./assets/fonts/Satoshi-Medium.ttf'),
          'Satoshi-Bold': require('./assets/fonts/Satoshi-Bold.ttf'),
          // Alternative naming for different weights
          'Satoshi_400': require('./assets/fonts/Satoshi-Regular.ttf'),
          'Satoshi_500': require('./assets/fonts/Satoshi-Medium.ttf'),
          'Satoshi_700': require('./assets/fonts/Satoshi-Bold.ttf'),
        });
        console.log('Fonts loaded successfully');
      } catch (error) {
        console.log('Font loading error:', error);
      }
    } else {
      console.log('Web platform: Fonts loaded via CSS');
    }

    const loggedIn = await Commons.getFromAS(Constants.loggedIn);
    const user = await Commons.getUserObject();
    const language = await Commons.language();
    let count = 0;
    (await Commons.getNotifcations()).data.map((l) => {
      if (l.READ === 0) count++;
    });

    this.setState({
      initializationFinished: true,
      loggedIn,
      user,
      badgeText: count,
      language,
    });
    setTimeout(this.setDrawerItems, 250);
  }

  setDrawerItems = () => {
  };

  backPress = () => {
    this.navigation.navigation.pop(1);
    return true;
  };

  getNavigator() {
    return (
      <Stack.Navigator
        name="main"
        initialRouteName={Platform.OS === 'web' ? "home" : "login"}
        drawerContent={(props) => this.renderSideBar(props)}
        screenOptions={{
          drawerStyle: {
            backgroundColor: "#c6cbef",
            width: width * 0.85,
          },
        }}
        drawerPosition="left"
      >
        <Stack.Screen
          name="login"
          component={Login}
          initialParams={{
            restart: () => {
              this.setState({ loggedIn: Constants.LOGGED_IN });
            },
          }}
          options={{ headerShown: false }}
        />
        {/* <Stack.Screen
          name="shop"
          initialParams={loggedIn ? {} : {
            restart: () => {
              this.setState({ loggedIn: Constants.LOGGED_IN });
            },
          }}
          component={loggedIn ? Delivery : Login}
          options={{ headerShown: false }}
        /> */}
        <Stack.Screen
          name="home"
          component={Home}
          options={{ headerShown: false }}
        />
        <Stack.Screen
          name="orderNow"
          component={OrderNow}
          options={{ headerShown: false }}
        />
        <Stack.Screen
          name="productDetails"
          component={ProductDetails}
          options={{ headerShown: false }}
        />

        <Stack.Screen
          name="contactus"
          component={ContactUs}
          options={{
            headerShown: false,
            headerBackVisible: true,
          }}
        />
        <Stack.Screen
          name="findus"
          component={FindUs}
          options={{ headerShown: false }}
        />
        <Stack.Screen
          name="aboutus"
          component={AboutUs}
          options={{ headerShown: false }}
        />
        <Stack.Screen
          name="myorders"
          // initialParams={loggedIn ? {} : {
          //   restart: () => {
          //     this.setState({ loggedIn: Constants.LOGGED_IN });
          //   },
          // }}
          // component={loggedIn ? MyOrders : Login}
          component={MyOrders}
          options={{ headerShown: false }}
        />
        <Stack.Screen
          name="profile"
          component={Profile}
          // component={loggedIn ? Profile : Login}
          // initialParams={{
          //   restart: (self) => {
          //     this.setState({ loggedIn: loggedIn ? Constants.LOGGED_OUT : Constants.LOGGED_IN });
          //     if (loggedIn) {
          //       // self.props.navigation.navigate("home");
          //       window.location = './home';
          //     }
          //   },
          // }}
          options={{ headerShown: false }}
        />
        <Stack.Screen
          name="settings"
          component={Settings}
          options={{ headerShown: false }}
        />
        {/* <Drawer.Screen name="driver" component={Driver} options={{ headerShown: false }} /> */}
        <Stack.Screen
          name="notifications"
          component={MyNotifications}
          options={{ headerShown: false }}
        />

        <Stack.Screen
          name="registerFirstStep"
          initialParams={{
            restart: () => {
              this.setState({ loggedIn: Constants.LOGGED_IN });
            },
          }}
          component={RegisterFirstStep}
          options={{ headerShown: false }}
          title={STRINGS.registration}
        />
        <Stack.Screen
          name="registerSecondStep"
          component={RegisterSecondStep}
          options={{ headerShown: false }}
          title={STRINGS.registration}
        />
        <Stack.Screen
          name="service"
          component={Service}
          options={{ headerShown: false }}
        />
        <Stack.Screen
          name="products"
          component={Products}
          options={{ headerShown: false }}
        />
        <Stack.Screen
          name="careers"
          component={Careers}
          options={{ headerShown: false }}
        />
        <Stack.Screen
          name="splash"
          component={SplashScreen}
          options={{ headerShown: false }}
        />
        <Stack.Screen
          name="pharmacovigilace"
          component={Pharmacovigilance}
          options={{ headerShown: false }}
        />
        <Stack.Screen
          name="activation"
          component={Activation}
          options={{ headerShown: false }} />

        <Stack.Screen
          name="OtpVerification"
          component={OtpVerification}
          options={{ headerShown: false }}
        />

        <Stack.Screen
          name="ClientHomePage"
          component={ClientHomePage}
          options={{ headerShown: false }}
        />

        <Stack.Screen
          name="StatementOfAccount"
          component={StatementOfAccount}
          options={{ headerShown: false }}
        />

        <Stack.Screen
          name="InvoiceDetails"
          component={InvoiceDetails}
          options={{ headerShown: false }}
        />

        <Stack.Screen
          name="OrderDetails"
          component={OrderDetails}
          options={{ headerShown: false }}
        />

        <Stack.Screen
          name="InvoicesReturns"
          component={InvoicesReturns}
          options={{ headerShown: false }}
        />
        <Stack.Screen
          name="shop"
          component={Shop}
          options={{ headerShown: false }}
        />
        <Stack.Screen
          name="filters"
          component={Filters}
          options={{ headerShown: false }}
        />

        <Stack.Screen
          name="checkout"
          component={checkout}
          options={{ headerShown: false }}
        />
        <Stack.Screen
          name="appNotifications"
          component={Notifications}
          options={{ headerShown: false }}
        />
        <Stack.Screen
          name="appNotificationsSettings"
          component={NotificationsSettings}
          options={{ headerShown: false }}
        />
        <Stack.Screen
          name="other"
          component={Other}
          options={{ headerShown: false }}
        />
        <Stack.Screen
          name="offersAndBestSellers"
          component={OffersAndBestSellers}
          options={{ headerShown: false }}
        />

      </Stack.Navigator>
    );
  }
}

export default App;
